export default function() {
  const useQuizStepsCheckbox = document.querySelector('#use_quiz_steps');
  const stepsBlock = document.querySelector('#quiz_steps_list_block');
  const addQuizStepBtn = document.querySelector('#add_quiz_step_btn');
  const saveQuizStepsBtn = document.querySelector('#save_quiz_steps_btn');
  const quizMainParamsBlock = document.querySelector('#quiz_main_params');
  const manualTypeId = 1;
  const autoTypeId = 2;
  const quizeCreateTypeManual = document.querySelector('input[name="quiz_params[creating_type]"][value="' + manualTypeId +'"]');
  const quizeCreateTypeAuto = document.querySelector('input[name="quiz_params[creating_type]"][value="' + autoTypeId +'"]');

  if (!useQuizStepsCheckbox || !stepsBlock || !addQuizStepBtn || !saveQuizStepsBtn || !quizMainParamsBlock) {
    return;
  }

  useQuizStepsCheckbox?.addEventListener('click', function (e) {
    if (e.currentTarget.checked) {
      quizMainParamsBlock.classList.remove('d-none');

      if (quizeCreateTypeManual?.checked) {
        stepsBlock.classList.remove('d-none');
        addQuizStepBtn.classList.remove('d-none');
        saveQuizStepsBtn.classList.remove('d-none');
      }
    } else {
      stepsBlock.classList.add('d-none');
      addQuizStepBtn.classList.add('d-none');
      saveQuizStepsBtn.classList.add('d-none');
      quizMainParamsBlock.classList.add('d-none');
    }
  });

  quizeCreateTypeManual?.addEventListener('click', function (e) {
    if (e.currentTarget.checked) {
      stepsBlock.classList.remove('d-none');
      addQuizStepBtn.classList.remove('d-none');
      saveQuizStepsBtn.classList.remove('d-none');
    }
  });

  quizeCreateTypeAuto?.addEventListener('click', function (e) {
    if (e.currentTarget.checked) {
      stepsBlock.classList.add('d-none');
      addQuizStepBtn.classList.add('d-none');
      saveQuizStepsBtn.classList.add('d-none');
    }
  });
}